<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="TXS"> </p>
<p class="TXS"> </p>
<p class="DED"><span class="ePub-I">To my friends whose astonishing generosity and sacrifice made possible not just this book but my continued survival.</span></p>
<p class="DEDL"><span class="ePub-I">I can’t name you all—I don’t even know who all of you are—so I’ll name none. You know who you are.</span></p>
<p class="DEDL"><span class="ePub-I">Neither words nor riches can ever repay what I owe you. My awe, humility, and gratitude will live so long as I. As will my love.</span></p>
<p class="DEDL"><span class="ePub-I">Thank you.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f11e48b4